<ng-template
    #numberInput
    let-row="row"
    let-column="column"
    let-rowIndex="rowIndex"
    let-rowCount="rowCount"
>
    <ng-container *ngIf="isEditable(row)">
        <input
            class="form-control"
            type="number"
            (change)="onModelChanged($event, row, rowIndex)"
            (keyup.enter)="onEnterPressed($event)"
            (keydown.enter)="onEnterPressed($event)"
            [(ngModel)]="row[column.value]"
            onwheel="return false;"
            pInputText
        />
    </ng-container>
    <ng-container *ngIf="!isEditable(row)">
        {{ row[column.value] | number: column.numberPipe }}
    </ng-container>
</ng-template>

<ng-template
    #textInput
    let-row="row"
    let-column="column"
    let-rowIndex="rowIndex"
    let-rowCount="rowCount"
>
    <ng-container *ngIf="isEditable(row)">
        <input
            class="form-control"
            (change)="onModelChanged($event, row, rowIndex)"
            [(ngModel)]="row[column.value]"
            (keyup.enter)="onEnterPressed($event)"
            (keydown.enter)="onEnterPressed($event)"
            pInputText
        />
    </ng-container>
    <ng-container *ngIf="!isEditable(row)">
        {{ row[column.value] }}
    </ng-container>
</ng-template>

<ng-template
    #optionButtons
    let-row="row"
    let-column="column"
    let-rowIndex="rowIndex"
    let-rowCount="rowCount"
>
    <div
        class="dropdown"
        *ngIf="hasVisibleButtonOptions(row, rowIndex, rowCount)"
    >
        <button
            class="btn btn-link dropdown-toggle"
            type="button"
            id="drop-down-menu-{{ rowIndex }}"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            role="button"
        >
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
        </button>
        <div
            [attr.id]="'sdropMenu' + rowIndex"
            class="dropdown-menu special-dropdown-menu"
            [attr.aria-labelledby]="'drop-down-menu-' + rowIndex"
        >
            <ng-container *ngFor="let option of column.options">
                <button
                    *ngIf="isButtonVisible(option, row, rowIndex, rowCount)"
                    [attr.title]="option.value"
                    type="button"
                    class="btn btn-secondary btn-sm full-width no-border"
                    [ngClass]="option.class"
                    (click)="
                        onButtonOptionClicked($event, row, option, rowIndex)
                    "
                >
                    {{ option.value }}
                </button>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template
    #hyperlink
    let-row="row"
    let-column="column"
    let-rowIndex="rowIndex"
    let-rowCount="rowCount"
>
    <a
        [href]="getColumnHref(row, column)"
        target="_blank"
        class="btn btn-sm btn-link"
        >{{ getLinkName(row, row[column.value]) }}</a
    >
</ng-template>

<ng-template
    #dateInput
    let-row="row"
    let-column="column"
    let-rowIndex="rowIndex"
    let-rowCount="rowCount"
>
    {{ row[column.value] | date: column.format || "yyyy-MM-dd" }}
</ng-template>
